import React from 'react';
import { Layout, Button, Dropdown, Space, Flex, Image } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Header.css';

const { Header: AntHeader } = Layout;

// Demo mode: authentication is disabled. The "Đăng nhập" button simply
// redirects to the payment (deposit) page so the flow can be demoed.
const DEMO_DEPOSIT_PATH = '/deposit/1';

interface HeaderProps {
  onAuthChange?: () => void;
}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const languageItems = [
    {
      key: 'vi',
      label: 'Tiếng Việt',
      onClick: () => handleLanguageChange('vi'),
    },
    {
      key: 'en',
      label: 'English',
      onClick: () => handleLanguageChange('en'),
    },
  ];

  const handleLogoClick = () => {
    navigate('/');
  };

  // Demo: redirect to the payment page instead of opening a login modal.
  const handleLoginClick = () => {
    navigate(DEMO_DEPOSIT_PATH);
  };

  return (
    <AntHeader className="app-header">
      <Flex justify="space-between" align="center" className="header-content">
        {/* Logo */}
        <Flex align="center" className="logo" onClick={handleLogoClick}>
          <Image
            src="/logo.png"
            alt="ATPlay"
            className="logo-image"
            preview={false}
            fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='40'%3E%3Ctext x='0' y='30' font-size='24' font-weight='bold' fill='%231890ff'%3EATPlay%3C/text%3E%3C/svg%3E"
          />
        </Flex>

        {/* Right side controls */}
        <Flex align="center" className="header-right">
          <Space size="middle">
            {/* Language Switch */}
            <Dropdown
              menu={{ items: languageItems }}
              placement="bottomRight"
              trigger={['click']}
            >
              <Button type="text" icon={<GlobalOutlined />} className="language-btn">
                {i18n.language === 'vi' ? 'VI' : 'EN'}
              </Button>
            </Dropdown>

            {/* Login button -> redirects to payment page (demo) */}
            <Button type="primary" className="login-btn" onClick={handleLoginClick}>
              {t('gameList.depositNow')}
            </Button>
          </Space>
        </Flex>
      </Flex>
    </AntHeader>
  );
};

export default Header;
